export const NOTIFICATIONS_URL = `/api/notifications/deployments`;
